import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { cookieKeys, getCookie } from "../../services/Cookies";
import { getRequest, postRequest, putRequest } from "../../services/ApiServices";
import { cookieObj } from "../../models/cookieObj";
import { makeStyles } from "@material-ui/core/styles";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Paper from "@material-ui/core/Paper";
import { Header } from "../../shared";
import { useHistory } from "react-router-dom";
import { Box } from "@material-ui/core";
import { CommonCss } from "../../services/CommonCss";
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import ReactGA from 'react-ga';
import { ToastSuccess, ToastError } from "../../services/ToastMsg";
import { LOADING } from '../../action';
import { useDispatch } from 'react-redux';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import { logUserActivity } from "../../services/FunctionServices";
import CloseIcon from '@mui/icons-material/Close';
//import pdf from "../../../OTPDOCUMANTATION"
const useStyles = makeStyles((theme) => ({
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    selectedClass: {
        "&:hover": {
            color: "#FF4717",
            border: "2px solid #FF4717",
        },
        width: "120px",
        background: "#FF4717",
        border: "2px solid #FF4717",
        borderRadius: "6px",
        color: "#FFF",
    },
    unSelected: {
        width: "120px",
        border: "2px solid #FF4717",
        borderRadius: "6px",
        color: "#FF4717",
    },
}));
export default function Newdevice(props) {
    const { innerWidth: width, innerHeight: height } = window;
    const classes = useStyles();
    const commonClasses = CommonCss();
    const history = useHistory();
    const [otp, setOtp] = useState("");
    const [email, setemail] = useState("");
    const [open, setOpen] = React.useState(true);
    const [count, setCount] = useState(5);
   // let count = 0;
    const [innerHeight, setInnerHeight] = useState(height);
    const dispatch = useDispatch();
    const descriptionElementRef = React.useRef(null);
    const handleClose = () => {
        setOpen(false);
    };

    const lockuser = async(islocked) => {
     debugger
        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Authenticate/LoginLocked/${email}/${islocked}`;
        dispatch({ type: LOADING, payload: true });
        await postRequest(url,)
            .then((res) => {
                dispatch({ type: LOADING, payload: false });
                if(res.data.length){
                    history.push("/sign-in")
                    ToastError("Your Account has been Locked. Please contact the administrator to Unlock your Account.")
                }

            })
            .catch((error) => {
                debugger
                setCount(count + 1);
                dispatch({ type: LOADING, payload: false });
                ToastSuccess("Invalid OTP");
            });
    }

    const SubmitOtp = async () => {
        // count = count + 1;
        
        
            debugger
            let DeviceId = getCookie('DeviceUniqueID')
            const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Authenticate/loginMFA/${email}/${otp}/${DeviceId}`;
            dispatch({ type: LOADING, payload: true });
            await postRequest(url)
                .then((res) => {
                    dispatch({ type: LOADING, payload: false });
                    if (res.status == 200) {
                        const assetTypes = [];
                        const serviceTypes = [];
                        const data = {
                            username: email, //"test@natobotics.com",

                        };
                        res.data.assetTypes.forEach((assetType) => {
                            assetTypes.push(assetType.assetType);
                        });
                        res.data.userServices.forEach((serviceType) => {
                            serviceTypes.push(serviceType.service);
                        });
                        const userData = {
                            name: res.data.userName,
                            username: data.username,
                            type: res.data.userType,
                            token: res.data.token,
                            clientId: res.data.clientId,
                            userRole: res.data.userRole,
                            clientName: res.data.clientName,
                            profileImg: res.data.profilepicture ? res.data.profilepicture : "default_image.png",
                            expiration: res.data.expiration,
                            assetTypes: assetTypes.join(','),
                            serviceTypes: serviceTypes.join(','),
                            resetPassword: res.data.resetPassword,
                            bM_ACCESS_STATUS: res.data.bM_ACCESS_STATUS,
                            defaultTab: res.data.defaultTab,
                            grouping: res.data.disableGrouping

                        };
                        localStorage.setItem("GlobalFilterSetting", res.data.globalFilerSetting);
                        /*ReactGA.set({userId:data.username});
                        ReactGA.set({username:data.username.split('@')[0]});
                        ReactGA.set({userdomain:data.username.split('@')[1]});
                        ReactGA.set({usertype:res.data.userType});
                        ReactGA.set({userrole:res.data.userRole});
                        ReactGA.set({userclientname:res.data.clientName});
                        ReactGA.set({userservice:serviceTypes.join(',')});*/
                        ReactGA.set({ userId: data.username });
                        ReactGA.event({
                            category: 'User',
                            action: 'Logged in',
                            userId: data.username,
                            username: data.username.split('@')[0],
                            userdomain: data.username.split('@')[1],
                            usertype: res.data.userType,
                            userrole: res.data.userRole,
                            userclientname: res.data.clientName,
                            userservice: serviceTypes.join(','),


                        });
                        ////
                        //coensole.log(res.data.expiration);
                        cookieKeys({ ...cookieObj, ...userData }, res.data.expiration);
                        if (res.data.userRole == "ClientUser" || res.data.userRole == "Client User") {
                            if (res.data.userType == "Bunker Master Only" && res.data.bM_ACCESS_STATUS !== "Approved") {
                                history.push("/dashboard/bunkerMaster")
                            }
                            else if (res.data.userType == "Bunker Master Only" && res.data.bM_ACCESS_STATUS == "Approved") {
                                history.push("/dashboard/bunker-master")
                            }
                            else {
                                history.push("/dashboard");
                            }
                        }
                        else {
                            history.push("/dashboard/admin");
                        }
                        logUserActivity('Login');
                    } else {
                        ToastSuccess("Invalid OTP");
                    }

                })
                .catch((error) => {
                    debugger
                    setCount(count - 1);
                    dispatch({ type: LOADING, payload: false });
                    ToastSuccess("Invalid OTP");
                    if (count == 1) {
                        lockuser(true);
                    }
                });
        
    }
    React.useEffect(() => {
        debugger
        setemail(props.match.params.email);
    }, [props.match.params.email]);
    return (

        <Box overflowX="hidden">
            <Header />
            <Box bgcolor="#1A1A31" height={innerHeight - 123 + "px"}>
                <Box className={commonClasses.navContainer} height={1}>
                    <Box
                        display="flex"
                        className={commonClasses.alignItemsStretch}
                        height={1}
                    >
                        <Dialog
                            open={open}
                            //onClose={handleClose}
                            aria-labelledby="scroll-dialog-title"
                            aria-describedby="scroll-dialog-description"
                        >
                            <DialogTitle id="scroll-dialog-title">Security Alert</DialogTitle>
                            <DialogContent>
                                <DialogContentText
                                    id="scroll-dialog-description"
                                    ref={descriptionElementRef}
                                    tabIndex={-1}
                                >
                                    <p>We noticed a new sign-in to your VPS Account on a Customer Portal.</p>
                                  
                                    <p className="subtitle">Note: One Time Password(OTP) has been sent to {email == "admin@vpsveritas.com" ? "CustomerPortalEnquiries@vpsveritas.com" : email }</p><br />
                                    <p className="subtitle">Please do check your JUNK/SPAM email folder for OTP!</p>
                                    <br></br>
                                    <a className="subtitle" style={{ cursor: "pointer", textDecoration: "underline" }} href={require('../../../OTPDOCUMANTATION/OTP_FLow_Customer_Notice.pdf')} target = "_blank">Why I am getting OTP ?</a>
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleClose}>OK</Button>
                            </DialogActions>
                        </Dialog>

                        <Box width={0.5}>
                            <Box pt={3} width={0.6}>
                                <Paper className="loginpg"
                                    elevation={3}

                                >

                                    <Box display="flex" alignItems="center" height="400px">
                                        <Box display="block">
                                            <Box component="h1" mt={0} fontWeight="500">
                                                More authentication Needed!
                                            </Box>
                                            <form className={classes.form} noValidate>
                                                <Box component="span" fontSize={14} fontWeight="500">
                                                    Note: Please input the One Time password which was sent to {email == "admin@vpsveritas.com" ? "CustomerPortalEnquiries@vpsveritas.com" : email}
                                                </Box>

                                                <TextField
                                                    variant="outlined"
                                                    margin="dense"
                                                    required
                                                    fullWidth
                                                    id="otp"
                                                    type="number"
                                                    name="otp"
                                                    autoComplete="otp"
                                                    placeholder="One Time Password"
                                                    autoFocus
                                                    onChange={(e) => {
                                                        let value = e.target.value;

                                                        setOtp(value.toString())
                                                    }}
                                                />
                                                <span>{count<5 && count>0?
                                                <Box fontWeight="400" color="red">Attempts Remaining: {count}</Box>
                                                :""}</span>
                                                <Box display="flex">
                                                    <Box fontWeight="400">Your One Time Password(OTP) is confidential.
                                                        Please do not share it with anyone via e-mail, phone or any other medium.</Box>
                                                </Box>

                                            </form>

                                            <Box
                                                mt={3}
                                                display="flex"
                                                className={commonClasses.justifyContentBetween}
                                            >
                                                <Box>
                                                    <ButtonGroup disableElevation>
                                                        <Button mr={3}
                                                            className={classes.selectedClass}
                                                            onClick={() => SubmitOtp()}
                                                        >
                                                            Submit
                                                        </Button>
                                                        <Button
                                                            className="cancel-btn"

                                                            onClick={() => {
                                                                cookieKeys(cookieObj, 0);
                                                                localStorage.clear();
                                                                // setActiveKey(
                                                                //     item.screenname.toLowerCase().split(" ").join("_")
                                                                // );
                                                                history.push("/sign-in");
                                                            }}
                                                        >
                                                            Cancel
                                                        </Button>
                                                    </ButtonGroup>
                                                </Box>
                                            </Box>
                                        </Box>{" "}
                                    </Box>
                                </Paper>
                            </Box>
                        </Box>
                        <Box width={0.5}>
                            <Box
                                display="flex"
                                justifyContent="flex-end"
                                height={1}
                                alignItems="flex-end"
                            >
                                <Box
                                    component="img"
                                    src={
                                        process.env.REACT_APP_CUSTOMER_PORTAL_URL +
                                        "assets/images/arrows.png"
                                    }
                                    mb={16}
                                    mr={5}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
